import { Encoder, MGPFallible } from '@everyboard/lib';
import { MoveCoord } from '../../jscaip/MoveCoord';
import { MoveCoordToCoord } from '../../jscaip/MoveCoordToCoord';
import { RulesFailure } from '../../jscaip/RulesFailure';
export class TeekoDropMove extends MoveCoord {
    static encoder = MoveCoord.getEncoder(TeekoDropMove.from);
    static from(coord) {
        return new TeekoDropMove(coord.x, coord.y);
    }
    toString() {
        return 'TeekoMove' + this.coord.toString();
    }
    equals(other) {
        if (other instanceof TeekoDropMove) {
            return super.equals(other);
        }
        else {
            return false;
        }
    }
}
export class TeekoTranslationMove extends MoveCoordToCoord {
    static encoder = MoveCoordToCoord.getFallibleEncoder(TeekoTranslationMove.from);
    static from(start, end) {
        if (start.equals(end)) {
            return MGPFallible.failure(RulesFailure.MOVE_CANNOT_BE_STATIC());
        }
        else {
            return MGPFallible.success(new TeekoTranslationMove(start, end));
        }
    }
    toString() {
        return 'TeekoMove(' + this.getStart().toString() + ' -> ' + this.getEnd().toString() + ')';
    }
    equals(other) {
        if (other instanceof TeekoTranslationMove) {
            return super.equals(other);
        }
        else {
            return false;
        }
    }
}
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var TeekoMove;
(function (TeekoMove) {
    TeekoMove.encoder = Encoder.disjunction([
        (move) => move instanceof TeekoDropMove,
        (move) => move instanceof TeekoTranslationMove,
    ], [
        TeekoDropMove.encoder,
        TeekoTranslationMove.encoder,
    ]);
})(TeekoMove || (TeekoMove = {}));
